import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import CellCulture from './cell-culture';
import CellCultureDetail from './cell-culture-detail';
import CellCultureUpdate from './cell-culture-update';
import CellCultureDeleteDialog from './cell-culture-delete-dialog';

const CellCultureRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<CellCulture />} />
    <Route path="new" element={<CellCultureUpdate />} />
    <Route path=":id">
      <Route index element={<CellCultureDetail />} />
      <Route path="edit" element={<CellCultureUpdate />} />
      <Route path="delete" element={<CellCultureDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default CellCultureRoutes;
